module.exports = __webpack_public_path__ + "static/kossuth-DND3_FnP-44a6d78e44bcbcf844c64a9ead2e4353.webp";